(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ShopperReports', ShopperReports)
      .constant('UserCohort', {
        all: { value: 'All' },
        tf : { value: 'TrueFit', parent: 'All' },
        nonTF: { value: 'NonTrueFit', parent: 'All'},
        tfReg: { value: 'TrueFitRegistered', parent: 'TrueFit'},
        tfSiteReg: { value: 'TrueFitSiteRegistered', parent: 'TrueFitRegistered' },
        tfTravellingReg: {value: 'TrueFitTravellingRegistered', parent: 'TrueFitRegistered' },
        tfIPReg: { value: 'TrueFitIPRegistered', parent: 'TrueFit' },
        newTFUsers: {value: 'NewTrueFitUsers' },
        newTFReg: {value: 'NewTrueFitRegistered', parent: 'NewTrueFitUsers' },
        newTFSiteReg: {value: 'NewTrueFitSiteRegistered', parent: 'NewTrueFitRegistered' },
        newTFTravellingReg: {value: 'NewTrueFitTravellingRegistered', parent: 'NewTrueFitRegistered' },
        newTFIPReg: {value: 'NewTrueFitIPRegistered', parent: 'NewTrueFitUsers' },
        tfAllTime: {value: 'TrueFitAllTime'},
        tfSiteAllTime: {value: 'TrueFitSiteAllTime', parent: 'TrueFitAllTime'},
        tfTravellingAllTime: {value: 'TrueFitTravellingAllTime', parent: 'TrueFitAllTime'}
      });

  function ShopperReports(ConsumerChart, StandardReports, Callout, UserLine, UserCohort, CalloutLabelService){

    var userLines = {
      tf: UserLine('tfLine', 'TF'),
      nonTF: UserLine('nonTFLine', 'Non-TF'),
      sitewideWithBots: UserLine('totalLine', 'Sitewide + Bots'),
      totalTF: UserLine('tfLine', 'Total TF', 'total'),
      tfRegistered: UserLine('registered', 'Registered'),
      siteRegistered: UserLine('siteRegistered', 'Site'),
      travellingRegistered: UserLine('travellingRegistered', 'Traveling'),
      ipRegistered: UserLine('ipRegistered', 'Instant Profile')
    };

    var filterConfig = function (userCohort, includeBots) {
      var botCriteria = includeBots ? {} : { isBot: false };
      var userCohortCriteria = {userCohort: userCohort};
      return _.merge(botCriteria, userCohortCriteria);
    };

    return {
      userDetails: userDetails,
      activeUserConfig: activeUserConfig,
      tfActiveUserConfig: tfActiveUserConfig,
      newUserConfig: newUserConfig,
      tfPercentDetails: tfPercentDetails,
      tfActiveUserRecipientConfig: tfActiveUserRecipientConfig,
      newRecipientProfilesConfig: newRecipientProfilesConfig,
      newRecipientProfileUsersConfig: newRecipientProfileUsersConfig
    };

    function userDetails(data, dataConfig, aggFn) {
      var lineData = _.map(dataConfig.dataParams, function (config) {
        var chartData = ConsumerChart.getChartData(data.dateMetrics, config.filter);
        return { lineType: config.getLineType(), data: chartData, label: config.getLabel() }
      });

      var summaryData = _.reduce(dataConfig.summaryParams, function (acc,line) {
        var chartData = ConsumerChart.getChartData(data.dateMetrics, filterConfig(line.userCohort.value,
            line.userCohort === UserCohort.all));
        acc[line.attributeName] = _.round(aggFn(chartData, 'value'));
        return acc;
      }, {});

      var summaryPercent = _.reduce(dataConfig.summaryParams, function (acc,line) {
        if(line.percentOutOfAttributeName) {
          var chartData = ConsumerChart.getChartData(data.dateMetrics, filterConfig(line.userCohort.parent, false));
          var totalValue = line.userCohort.parent === UserCohort.all.value ? (summaryData.tf + summaryData.nonTF) :
              _.round(aggFn(chartData, 'value'));
          acc[line.percentOutOfAttributeName] = StandardReports.percentTotal(summaryData[line.attributeName], totalValue);
        }
        return acc;
      }, {});

      return _.merge({lineData: lineData}, summaryData, summaryPercent);
    }

    function activeUserConfig(chartType, detailLevel, section) {
      var labelValues = Callout.labelValueConfig([
        CalloutLabelService.tf(section),
        CalloutLabelService.nonTF(section),
        CalloutLabelService.sitewideWithBots(section)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, false, section), {
        dataParams:[
          lineDetails(UserCohort.tf, userLines.tf),
          lineDetails(UserCohort.nonTF, userLines.nonTF),
          lineDetails(UserCohort.all, userLines.sitewideWithBots, true)
        ]
      })
    }

    function tfActiveUserConfig(chartType, detailLevel, section) {
      var labelValues = Callout.tfUsersConfig([
        CalloutLabelService.sectionTotal(section, null, UserCohort.tf),
        CalloutLabelService.tfRegistered(section, null, UserCohort.tfReg),
        CalloutLabelService.siteRegistered(section, null, UserCohort.tfSiteReg),
        CalloutLabelService.travellingRegistered(section, null, UserCohort.tfTravellingReg),
        CalloutLabelService.ipRegistered(section, null, UserCohort.tfIPReg)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, true, section), {
        dataParams: [
          lineDetails(UserCohort.tfSiteReg, userLines.siteRegistered),
          lineDetails(UserCohort.tfTravellingReg, userLines.travellingRegistered),
          lineDetails(UserCohort.tfIPReg, userLines.ipRegistered)
        ]
      })
    }

    function tfActiveUserRecipientConfig(chartType, detailLevel, section) {
      var labelValues = Callout.labelValueConfig([
        CalloutLabelService.tfUsersWithRecipient(section, null, UserCohort.tfReg),
        CalloutLabelService.tfUsersWithRecipientSite(section, null, UserCohort.tfSiteReg),
        CalloutLabelService.tfUsersWithRecipientTravelling(section, null, UserCohort.tfTravellingReg)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, false, section), {
        dataParams: [
          lineDetails(UserCohort.tfReg, userLines.tfRegistered),
          lineDetails(UserCohort.tfSiteReg, userLines.siteRegistered),
          lineDetails(UserCohort.tfTravellingReg, userLines.travellingRegistered)
        ]
      })
    }

    function newRecipientProfilesConfig(chartType, detailLevel, section) {

      var labelValues = Callout.labelValueConfig([
        CalloutLabelService.tfProfiles(section, null, UserCohort.newTFReg),
        CalloutLabelService.tfProfilesSite(section, null, UserCohort.newTFSiteReg),
        CalloutLabelService.tfProfilesTravelling(section, null, UserCohort.newTFTravellingReg)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, true, section), {
        dataParams:[
          lineDetails(UserCohort.newTFSiteReg, userLines.siteRegistered),
          lineDetails(UserCohort.newTFTravellingReg, userLines.travellingRegistered)
        ]
      });
    }

    function newRecipientProfileUsersConfig(chartType, detailLevel, section) {

      var labelValues = Callout.labelValueConfig([
        CalloutLabelService.tfUsersWithRecipient(section, null, UserCohort.newTFReg),
        CalloutLabelService.tfUsersWithRecipientSite(section, null, UserCohort.newTFSiteReg),
        CalloutLabelService.tfUsersWithRecipientTravelling(section, null, UserCohort.newTFTravellingReg)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, false, section), {
        dataParams:[
          lineDetails(UserCohort.newTFReg, userLines.tfRegistered),
          lineDetails(UserCohort.newTFSiteReg, userLines.siteRegistered),
          lineDetails(UserCohort.newTFTravellingReg, userLines.travellingRegistered)
        ]
      });
    }

    function newUserConfig(chartType, detailLevel, section) {
      var labelValues = Callout.tfUsersConfig([
        CalloutLabelService.sectionTotal(section, null, UserCohort.newTFUsers),
        CalloutLabelService.tfRegistered(section, null, UserCohort.newTFReg),
        CalloutLabelService.siteRegistered(section, null, UserCohort.newTFSiteReg),
        CalloutLabelService.travellingRegistered(section, null, UserCohort.newTFTravellingReg),
        CalloutLabelService.ipRegistered(section, null, UserCohort.newTFIPReg)
      ]);
      return _.merge(commonUserConfig(labelValues, chartType, detailLevel, true, section), {
        dataParams:[
          lineDetails(UserCohort.newTFSiteReg, userLines.siteRegistered),
          lineDetails(UserCohort.newTFTravellingReg, userLines.travellingRegistered),
          lineDetails(UserCohort.newTFIPReg , userLines.ipRegistered)
        ]
      })
    }

    function lineDetails(userCohort, userLine, includeBots) {
      return _.merge(userLine, {filter: filterConfig(userCohort.value, includeBots)});
    }

    function commonUserConfig(labelValueLayout, chartType, detailLevel, drawAreaChart, section) {
      return {
        summaryParams: labelValueLayout.labelValues,
        chartLayout: function(title, chartToolTipProp) {
          return ConsumerChart.getChartConfig(chartType, title, drawAreaChart, detailLevel, chartToolTipProp, section);
        },
        summaryLayout: labelValueLayout
      }
    }

    function tfPercentDetails(data) {
      var metricValues = _.map(data.dateMetrics, function (metricValue) {
        return {
          date: metricValue.startDate,
          value: metricValue.value
        }
      });
      var lineData = [
          {lineType: 'tfLine', data: metricValues, label: 'TF'}
      ];

      return {
        lineData: lineData, tfPercent: data.meanValue
      }
    }

  }
})();